import { TaxonomyManager } from "./Taxonomy";

export default function Brands() {
  return (
    <TaxonomyManager
      kind="brands"
      title="Gerenciar Marcas"
      subtitle="Crie, renomeie, ordene e ative as marcas da loja. O menu Marcas e as páginas de cada marca são atualizados automaticamente."
      placeholder="Nova marca — ex.: Max Titanium, Growth"
      helpText="Excluir só é permitido quando nenhum produto usa a marca. Marcas inativas somem do menu e da página de marcas; os produtos continuam no catálogo."
      testidPrefix="brand"
      noun="Marca"
    />
  );
}
